<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-19 09:04:43
 * @LastEditTime : 2020-01-21 11:34:40
 * @LastEditors  : Please set LastEditors
 -->
<!--  -->
<template>
  <div class="div_ucRoute">

    <div class="div_title">路线</div>

    <UCSearchInput
      class="uc_searchInput"
      ref="ucSearchInput"
    ></UCSearchInput>

    <UCRoutePOISelect
      class="uc_routePOISelect"
      ref="ucPOISelect"
      v-show="ucSetting.ucPOISelectVisible"
    ></UCRoutePOISelect>

    <UCBusRouteLine
      class="uc_busRouteLine"
      ref="ucBusRouteLine"
      v-show="ucSetting.ucBusLineVisible"
    ></UCBusRouteLine>

    <UCDriveRouteLine
      class="uc_driveRouteLine"
      ref="ucDriveRouteLine"
      v-show="ucSetting.ucDriveLineVisible"
    ></UCDriveRouteLine>

  </div>
</template>

<script>
import UCSearchInput from "./UCSearchInput.vue";
import UCBusRouteLine from "./UCBusRouteLine.vue";
import UCDriveRouteLine from "./UCDriveRouteLine.vue";
import UCRoutePOISelect from "./UCRoutePOISelect.vue";

import { RouteSearchType, RouteSearchParams } from "./UCRouteJs.js";
// import { RouteFilter, RouteSearchResult } from "../model/Route.js";
import { POISearchFilter } from "../model/POISearch.js";
// import { ArrayUtility } from "../../../utility/common/ArrayUtility";

export default {
  name: "UCRoute",
  data() {
    return {
      ucSetting: {
        ucPOISelectVisible: true,

        ucBusLineVisible: false,

        ucDriveLineVisible: false
      },

      searchParams: null,

      //搜索的输入参数
      searchInputParams: null,

      curMap: null
    };
  },

  components: {
    UCSearchInput,
    UCBusRouteLine,
    UCDriveRouteLine,
    UCRoutePOISelect
  },

  computed: {},

  mounted() {},

  methods: {
    /**
     * 初始化
     */
    init(params) {
      if (params) {
        this.searchInputParams = params;
      } else {
        this.searchInputParams = new RouteSearchParams();
      }

      this.$refs.ucSearchInput.init(this.searchInputParams);

      this.$refs.ucPOISelect.searchParams = null;
      this.$refs.ucPOISelect.init();

      this.$refs.ucBusRouteLine.searchParams = null;
      this.$refs.ucBusRouteLine.init();

      this.$refs.ucDriveRouteLine.searchParams = null;
      this.$refs.ucDriveRouteLine.init();

      this.ucSetting.ucBusLineVisible = false;
      this.ucSetting.ucDriveLineVisible = false;

      this._initEvent();

      //针对地图选点：如果起点和终点的搜索参数是完整的，触发查找方法
      let isIntegrity = this.searchInputParams.checkStartAndEndPOIIntegrity();
      if (isIntegrity) {
        this._routePOIsSelectFinishHandler(this.searchInputParams);
      }
      
    },

    getSearchInputParams() {
      if (this.$refs.ucSearchInput) {
        return this.$refs.ucSearchInput.getSearchParams();
      } else {
        return this.searchInputParams;
      }
    },

    on_searchInput_searchClick(callback) {
      if (callback) {
        this.$refs.ucSearchInput.on_searchClick(callback);
      }
    },
    /**
     * 绑定线路搜索完成事件监听
     */
    on_drive_routeSearchFinished(callback) {
      if (this.$refs.ucDriveRouteLine) {
        this.$refs.ucDriveRouteLine.on_routeSearchFinished(callback);
      }
    },

    on_drive_poiSearchFinished(callback) {
      if (this.$refs.ucPOISelect) {
        this.$refs.ucPOISelect.on_poiSearchFinished(callback);
      }
    },

    /**
     * 绑定线路项单击事件监听
     */
    on_drive_routeItemClick(callback) {
      if (this.$refs.ucDriveRouteLine) {
        this.$refs.ucDriveRouteLine.on_routeItemClick(callback);
      }
    },

    on_bus_busTransferInfoSearchFinished(callback) {
      if (this.$refs.ucBusRouteLine) {
        this.$refs.ucBusRouteLine.on_busTransferInfoSearchFinished(callback);
      }
    },

    on_bus_lineItemClick(callback) {
      if (this.$refs.ucBusRouteLine) {
        this.$refs.ucBusRouteLine.on_lineItemClick(callback);
      }
    },

    on_bus_segmentItemClick(callback) {
      if (this.$refs.ucBusRouteLine) {
        this.$refs.ucBusRouteLine.on_segmentItemClick(callback);
      }
    },

    on_bus_segmentEndNameClick(callback) {
      if (this.$refs.ucBusRouteLine) {
        this.$refs.ucBusRouteLine.on_segmentEndNameClick(callback);
      }
    },

    on_routeSearchTypeChange(callback) {
      this.$refs.ucSearchInput.on_searchTypeChange(callback);
    },

    on_clearRoute(callback) {
      this.$refs.ucSearchInput.on_clearRoute(callback);
    },

    /**
     * 事件初始化
     */
    _initEvent() {
      this.$refs.ucSearchInput.off_searchClick(this._routeSearchClickHandler);
      this.$refs.ucSearchInput.on_searchClick(this._routeSearchClickHandler);

      this.$refs.ucSearchInput.off_searchTypeChange(
        this._routeSearchTypeChangeHandler
      );
      this.$refs.ucSearchInput.on_searchTypeChange(
        this._routeSearchTypeChangeHandler
      );

      this.$refs.ucSearchInput.off_clearRoute(this._clearRouteHandler);
      this.$refs.ucSearchInput.on_clearRoute(this._clearRouteHandler);

      this.$refs.ucPOISelect.off_routePOIsSelectFinish(
        this._routePOIsSelectFinishHandler
      );
      this.$refs.ucPOISelect.on_routePOIsSelectFinish(
        this._routePOIsSelectFinishHandler
      );
    },

    /**
     * 搜索线路
     */
    _searchRoute(searchParams) {
      let searchType = searchParams.searchType;

      if (searchType === RouteSearchType.national_busTransfer) {
        this.$refs.ucBusRouteLine.searchParams = searchParams;
        this.$refs.ucBusRouteLine.init();
      } else if (searchType === RouteSearchType.national_drive) {
        this.$refs.ucDriveRouteLine.searchParams = searchParams;
        this.$refs.ucDriveRouteLine.init();
      }
    },

    /**
     * 触发线路搜索单击事件
     */
    _routeSearchClickHandler(params) {
      if (!params) return;

      this.searchParams = params;

      this.ucSetting.ucPOISelectVisible = true;
      this.ucSetting.ucDriveLineVisible = false;
      this.ucSetting.ucBusLineVisible = false;

      this.$refs.ucPOISelect.searchParams = params;
      this.$refs.ucPOISelect.mapFilter = POISearchFilter.createFilterFromMap(
        this.curMap
      );
      this.$refs.ucPOISelect.init();
    },

    _routeSearchTypeChangeHandler(params) {
      if (!this.searchParams) {
        this.searchParams = params;
      } else {
        this.searchParams.searchType = params.searchType;

        this.searchParams.driveViaPoints = params.driveViaPoints;

        this.searchParams.resetStartAndEndSuggestKey(params);
      }

      if (
        !this.searchParams.startPoint.suggestKey ||
        !this.searchParams.endPoint.suggestKey
      ) {
        return;
      }

      if (
        !this.searchParams.startPoint.POI ||
        !this.searchParams.endPoint.POI
      ) {
        this._routeSearchClickHandler(this.searchParams);
      } else {
        this._routePOIsSelectFinishHandler(this.searchParams);
      }
    },

    _routePOIsSelectFinishHandler(params) {
      this.searchParams = params;

      this.ucSetting.ucPOISelectVisible = false;

      if (params.searchType === RouteSearchType.national_drive) {
        this.ucSetting.ucDriveLineVisible = true;
        this.ucSetting.ucBusLineVisible = false;
      } else if (params.searchType === RouteSearchType.national_busTransfer) {
        this.ucSetting.ucBusLineVisible = true;
        this.ucSetting.ucDriveLineVisible = false;
      }

      this._searchRoute(params);
    },

    _clearRouteHandler() {
      this.ucSetting.ucPOISelectVisible = false;
      this.ucSetting.ucBusLineVisible = false;
      this.ucSetting.ucDriveLineVisible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.div_ucRoute {
  height: 100%;
  width: 100%;

  .div_title {
    text-align: center;
    width: 100%;
    // max-height: 5%;
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    font-weight: 700;
  }

  .uc_searchInput {
    max-height: 40%;
    width: 100%;
  }

  .uc_routePOISelect {
    max-height: 50%;
    width: 100%;
  }

  .uc_busRouteLine {
    // min-height: 50%;
    height: 60%;
    // max-height: 70%;
    width: 100%;
  }

  .uc_driveRouteLine {
    // min-height: 60%;

    height: 50%;

    // max-height: 70%;
    width: 100%;
  }
}
</style>
